import { jsx as _jsx } from "react/jsx-runtime";
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import * as React from 'react';
import { Link } from '../link';
export const BreadcrumbLink = (props) => {
    return (_jsx(Link, { href: props.href, color: "text.secondary", noWrap: true, underline: "hover", textTransform: "sentence", children: props.children }));
};
export const Breadcrumbs = (props) => {
    if (!props.items.length) {
        return null;
    }
    return (_jsx(MuiBreadcrumbs, { "aria-label": "breadcrumb", children: props.items.map(({ href, children }) => (_jsx(BreadcrumbLink, { href: href, children: children }, href))) }));
};
export const breadcrumbsStyle = {
    MuiBreadcrumbs: {
        styleOverrides: {
            ol: { flexWrap: 'nowrap' }
        }
    }
};
